import React from 'react';
import FeatureItem from '../elements/feature_item';
import Button from '../elements/button';
import { Arrow, Lightbulb, MapIdentify, Shop } from '../../assets/icons';
import '../../assets/css/sections/features.css';

const featuresData = [
    {
        icon: <img src={Lightbulb} alt="" />,
        title: "Educational Resources",
        description: "Learn best practices for sustainable and smart fish farming through expert-led courses.",
        link: "/learning"
    },
    {
        icon: <img src={MapIdentify} alt="" />,
        title: "Advanced Diagnostics",
        description: "AI-powered tools for early detection and prevention of aquaculture diseases.",
        link: "/aqua-doc"
    },
    {
        icon: <img src={Shop} alt="" />,
        title: "Multivendor E-commerce",
        description: "Connect with trusted suppliers for high-quality aquaculture products, equipment, and feed.",
        link: "/store"
    }
];

const Features = () => {
    return (
        <section className="features-section">
            <div className="container">
                {/* <h2 className="section-title">Our Key Features</h2> */}
                <div className="features-grid">
                    {featuresData.map((feature, index) => (
                        <FeatureItem
                            key={index}
                            icon={feature.icon}
                            title={feature.title}
                            description={feature.description}
                            link = {feature.link} // Add link prop to FeatureItem
                        />
                    ))}
                </div>
                <div className="features-action">
                    <Button 
                        text="Learn More"
                        variant="red"
                        icon={<img src={Arrow} alt="arrow" className='arrow_up' />}
                        onClick={() => window.location.href = '/about'}
                    />
                </div>
            </div>
        </section>
    );
};

export default Features;